import { anyFixExpr } from "../utils/formatRoute.js";
// FAA TI 6110.100b - section 8.13
export const ALTITUDE_VALIDATION_EXPRESSIONS = {
    hardAlt: /^\d\d\d$/,
    blockAlt: /^\d\d\dB\d\d\d$/,
    otpAlt: /^OTP\/\d\d\d$/,
    otp: /^OTP$/,
    vfrAlt: /^VFR\/\d\d\d$/,
    vfr: /^VFR$/,
    above: /^ABV\/\d\d\d$/,
    altFixAlt: new RegExp(`^\\d\\d\\d\\/${anyFixExpr.source}\\/\\d\\d\\d$`),
};
export const BEACON_EXPR = /^[0-7]{4}$/m;
export const GI_EXPR = /GI (C|\d{2}|[A-Z]{4}) `(.*)/m;
//# sourceMappingURL=expressions.js.map